import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllTaskcount = createAsyncThunk(
    'report/fetchAllTaskReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/task/count');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Task');
        }
    }
);



export const fetchAllTaskList = createAsyncThunk(
    'report/fetchAllTasklist',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/task`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Task');
        }
    }
);